import { RemixBrowser, useLocation, useMatches } from '@remix-run/react';
import * as Sentry from '@sentry/remix';
import { StrictMode, startTransition, useEffect } from 'react';
import { hydrateRoot } from 'react-dom/client';

/**
 * Sentry DSN, if provided it will initialize Sentry.
 * Otherwise, Sentry will not be initialized.
 * @type {string | undefined}
 */
const dsn = import.meta.env.SENTRY_DSN;
/**
 * The current Octopus environment name
 * @type {'production' | 'staging' | 'preview' | undefined}
 */
const environment = import.meta.env.OCT_ENVIRONMENT;

dsn &&
  Sentry.init({
    dsn,
    integrations: [
      Sentry.browserTracingIntegration({
        useEffect,
        useLocation,
        useMatches,
      }),
    ],
    captureActionFormDataKeys: {
      key_x: true,
      key_y: true,
    },
    environment,
    sendDefaultPii: true,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    tracesSampleRate: 1,
    tracePropagationTargets: ['localhost', /^oct(?:\.test)?\.flysas\.com$/],
  });

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>
  );
});
